import { createContext } from "react";

export type GoogleTagManagerProviderProps = {
  gtmId?: string;
};

export const GoogleTagManagerContext = createContext({});
